import { HeroSection } from "../components/home/HeroSection";
import { IndustriesSection } from "../components/home/IndustriesSection";
import { IntegrationsSection } from "../components/home/IntegrationsSection";
import { OperationsSection } from "../components/home/OperationsSection";
import { VisitorLifecycle } from "../components/home/VisitorLifecycle";
import { Footer } from "../components/layout/Footer";
import { Navbar } from "../components/layout/Navbar";
import { RequestDemo } from "./RequestDemo";

export function Home() {
  return (
    <div id="top" className="min-h-screen bg-white text-brand-ink">
      <Navbar />
      <main>
        <HeroSection />
        <VisitorLifecycle />
        <OperationsSection />
        <IndustriesSection />
        <IntegrationsSection />
        <RequestDemo />
      </main>
      <Footer />
    </div>
  );
}
